import axios from 'axios'
import store from '../store'

export default {
  isInitialized: false,
  getSession () {
    if (this.isInitialized) {
      return Promise.resolve()
    }
    this.isInitialized = true
    const jwt = window.localStorage.getItem('vendorPortalJwt')
    this.setToken(jwt)
    return this.getUserInfo()
  },
  authenticate (vendorCode, password) {
    return axios.post('api/vendors/login', { vendorCode, password })
      .then((r) => {
        this.setToken(r.data.token)
        return this.getUserInfo()
      })
  },
  getUserInfo () {
    return axios.get('api/vendors/info')
      .then((r) => {
        console.log(r.data)
        store.dispatch('loginModule/login', r.data)
      })
      .catch((e) => {
        this.logout()
      })
  },
  setToken (token) {
    axios.defaults.headers.common.Authorization = `Bearer ${token}`
    window.localStorage.setItem('vendorPortalJwt', token)
  },
  logout () {
    if (typeof axios.defaults.headers.common.Authorization !== 'undefined') {
      axios.defaults.headers.common.Authorization = null
    }
    window.localStorage.removeItem('vendorPortalJwt')
    store.dispatch('loginModule/logout')
  }
}
